import { render, staticRenderFns } from "./ProjectName.vue?vue&type=template&id=34d3657e&"
import script from "./ProjectName.vue?vue&type=script&lang=js&"
export * from "./ProjectName.vue?vue&type=script&lang=js&"
import style0 from "./ProjectName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports